import { theme } from '~/theme';

export const useSxStyles = () => {
  return {
    root: {
      paddingBottom: theme.spacing(3),
    },
    widgets: {
      display: 'flex',
      gap: theme.spacing(1),
      margin: theme.spacing(1),
    },
  };
};
